import { useEffect, useState } from "react";
import api from "../../api/api";
import { DataGridBase } from "../../components/DataGrid/DataGridBase";
import {
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro";
import moment from "moment";
import { CircularProgress } from "@mui/material";

/**
 * Tab Blacklist: mostra le email che SendGrid ha segnalato come
 * bounce permanente, spam report o unsubscribe.
 * Dati popolati dal webhook SendGrid (POST /api/newsletter/sg-webhook).
 */
export const NewsletterBlacklist = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const resp = await api.get("/newsletter/blacklist");
      setRows(resp.data || []);
    } catch (err) {
      console.error("Errore caricamento blacklist:", err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const renderEsiti = (raw) => {
    if (!raw) return null;
    const esiti = String(raw).split(",");
    return esiti.map((e) => {
      const v = e.trim();
      const cls =
        v === "bounced"
          ? "bg-red-100 text-red-800"
          : v === "spamreport"
          ? "bg-amber-100 text-amber-800"
          : v === "unsubscribed"
          ? "bg-gray-200 text-gray-800"
          : "bg-slate-100 text-slate-700";
      const label =
        v === "bounced"
          ? "Bounce"
          : v === "spamreport"
          ? "Spam"
          : v === "unsubscribed"
          ? "Unsubscribe"
          : v;
      return (
        <span
          key={v}
          className={`inline-block px-2 py-0.5 mx-0.5 rounded text-xs font-medium ${cls}`}
        >
          {label}
        </span>
      );
    });
  };

  const columns = [
    {
      field: "email",
      headerName: "Email",
      flex: 1.4,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "esiti",
      headerName: "Motivo",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => renderEsiti(params.row.esiti),
    },
    {
      field: "ultimo_evento",
      headerName: "Ultimo evento",
      flex: 0.9,
      headerAlign: "center",
      align: "center",
      renderCell: (params) =>
        params.row.ultimo_evento
          ? moment(params.row.ultimo_evento).format("DD/MM/YYYY HH:mm")
          : "-",
    },
    {
      field: "ultimo_errore",
      headerName: "Dettaglio",
      flex: 1.4,
      headerAlign: "center",
      align: "left",
      renderCell: (params) => (
        <span className="text-xs text-gray-600 truncate">
          {params.row.ultimo_errore || "-"}
        </span>
      ),
    },
  ];

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <div className="w-full flex flex-wrap-reverse md:flex-nowrap justify-between md:space-x-5 mb-2 gap-y-1">
          <div className="flex md:flex-nowrap md:w-fit w-full flex-wrap justify-center md:justify-start gap-x-2">
            <GridToolbarQuickFilter placeholder="Cerca..." />
          </div>
          <div className="flex justify-center md:justify-end md:mx-0 mx-auto items-center gap-2">
            <span className="text-sm text-gray-500">
              {rows.length} email in blacklist
            </span>
          </div>
        </div>
      </GridToolbarContainer>
    );
  }

  return (
    <div className="w-full md:h-[70vh] h-[70vh] relative el-container">
      {loading ? (
        <div className="flex items-center justify-center h-full">
          <CircularProgress />
        </div>
      ) : (
        <DataGridBase
          storageKey="newsletter_blacklist"
          slots={{ toolbar: CustomToolbar }}
          columns={columns}
          rows={rows}
          getRowId={(r) => r.email}
        />
      )}
    </div>
  );
};
